import React, { useState, useEffect } from 'react'
import VisualizacaoPadrao from '../../../../components/VisualizacaoPadrao'
import { useParams } from "react-router-dom";
import { visualizar } from '../../../../util/AcessoApi'

const Visualizacao = (props) => {
    let { id } = useParams();
    const [dados, setDados] = useState()

    useEffect(() => {
        if (id) {
            visualizar('/administracao/feriados', id,
                obj => 
                    setDados(obj.id ? {
                        id,
                        modulo: props.modulo,
                        titulo: 'Visualização de Feriados',
                        grupos: [
                            {
                                titulo: 'Dados Gerais',
                                colunas: [
                                    { titulo: 'Código', descricao: obj.id, tamanho: 'col-lg-6' },
                                    { titulo: 'Descrição', descricao: obj.descricao, tamanho: 'col-lg-6' },
                                    { titulo: 'Data Feriado', descricao: obj.data_feriado , tamanho: 'col-lg-6' },
                                    { titulo: 'Observação', descricao: obj.observacao, tamanho: 'col-lg-6' },
                                    { titulo: 'Data Registro', descricao: obj.data_registro_formatada, tamanho: 'col-lg-6' }
                                ]
                            },
                            
                        ]
                    } : { titulo: 'Visualização de Feriados' })
            )
        }
    }, [id])

    return dados ? <VisualizacaoPadrao data={dados} {...props} /> : null
}

export default Visualizacao